import React from 'react';
import styles from '../geschiedenis/geschiedenis.module.css'; // Import the CSS file for this page's specific styling

const Geschiedenis = () => {
  return (
    <main className={styles.main}>
        <section>
            <h1>
            Geschiedenis fanfare
            </h1>
        </section>
        <section>
            <p>
            In 1907 werd in het gehucht Borgt, gelegen langs het Rupelkanaal, een muziekvereniging opgericht.
            Deze geboorte verliep niet zonder problemen, want eigenlijk werden er twee verenigingen geboren, en zelfs deze tweeling zag niet tegelijkertijd het levenslicht.
            </p>
            <p>
            Aan het begin van 1907 stichtte een groep muziekliefhebbers een fanfare genaamd "De Nachtegaal" op het grondgebied van Vilvoorde. Maar sommige muzikanten waren het daar niet mee eens en bespraken de mogelijkheid om in Borgt, gelegen op het grondgebied van Grimbergen, een andere fanfare op te richten.        </p>
            <p>
            Zo werd de "tweeling" geboren, want de fanfare in Grimbergen en Borgt kreeg de naam "De Moedige Vrienden." Ze vroegen de heer Jozef Backx, een hoofdonderwijzer en muziekleraar aan de gemeenteschool in Vilvoorde, om dirigent te worden. De eerste repetitie met 18 muzikanten vond plaats in zaal Henri Sapon. De heer Van Dessel, een houtkoopman langs het kanaal, werd voorzitter en verschillende vooraanstaande personen traden toe tot het bestuur.
            </p>
        </section>

        <img
        className="pictures"
        src='../images/oude-foto.jpeg'
        alt="oude-foto"
        style={{ borderRadius: '7vmax' }}
        />

        <section>
            <p>
            In augustus 1907 verfraaide de fanfare de dorpsprocessie en in november gaf het jonge gezelschap met veel succes haar eerste Ceciliaconcert in de parochiekerk van Borgt. In 1908 maakte de fanfare haar eerste uitstapje naar de geboorteplaats van de heer Van Dessel. Het aantal muzikanten en ereleden groeide gestaag, mede dankzij financiële steun van de gemeente Grimbergen, waardoor ze nieuwe instrumenten konden aanschaffen.
            </p>
            <p>
            Helaas werd de opkomst onderbroken door het uitbreken van de Eerste Wereldoorlog, omdat de Duitse bezetter alle activiteiten, inclusief muzikale, verbood en zelfs de instrumenten moesten worden verstopt.
            </p>
        </section>
        <section>
            <p>
            In november 1918 keerde het normale leven langzaam terug, en ook de fanfare hervatte haar activiteiten met hernieuwde moed. Veel jonge muzikanten sloten zich aan, namen als Spolspoel Jan, Hoedemaeckers Pierre, Buys Frans, Raiglot Henri, Verstappen Andre, De Breucker Jean en Buys Frans, namen die nog steeds resoneren bij "De Moedige Vrienden," maar helaas zijn ze allemaal overleden.
            </p>
            <p>
            Na 25 jaar als dirigent werd in 1932 de heer J. Backx vervangen door de heer Jozef Jacobs, een strenge leider die discipline en toewijding bij de muzikanten bracht. Onder zijn leiding nam de fanfare deel aan tal van wedstrijden en muziekwedstrijden, vaak met groot succes, tot het uitbreken van de Tweede Wereldoorlog opnieuw voor een lange onderbreking zorgde.

            </p>
        </section>
        <section>
            <p>
            Intussen was voorzitter Van Dessel vervangen door de heer Stas Jules, die later benoemd werd tot notaris in Asse. De heer De Vleeschouwer nam tijdelijk het voorzitterschap over. Na een korte periode werd De Vleeschouwer opgevolgd door de heer H. Knop. Deze gedreven voorzitter tilde het artistieke niveau van onze vereniging omhoog, en zijn overlijden in 1952 was dan ook een groot verlies. Hij werd opgevolgd door Spolspoel Jan, terwijl Francois Doms erevoorzitter werd. Dit waren moeilijke naoorlogse tijden.
            </p>
            <p>
            De jongere generatie keerde zich af van de fanfaremuziek en gaf de voorkeur aan modernere muziek. In deze moeilijke jaren vond ook een wisseling van dirigent plaats. In 1960 werd Jacobs na 27 jaar opgevolgd door de jonge dirigent Remy Carleer, die de fanfare slechts vier jaar leidde. Ook verhuisde de fanfare in 1952 naar café "In de Wittepen". Ondanks de beperkte instroom bleven de oudere muzikanten de eer van de fanfare hoog houden en behaalden ze prijzen in verschillende wedstrijden (Malderen, Vosselaar, Mol, enz.) en provinciale competities.

            </p>
        </section>
        <section>
            <p>
            In 1965 werd Louis Adriaenssens, een muzikant bij de militaire muziekkapel van de zeemacht, de dirigent van het gezelschap. Halverwege de jaren zestig begon langzaam een kentering. Onder leiding van voorzitter Spolspoel en muziekleraar Pierre Hoedemaeckers begonnen jongeren zich aan te sluiten bij de fanfare, wat resulteerde in een groei van het aantal muzikanten. In 1981, na 29 jaar dienst, trad toenmalig voorzitter Jean Spolspoel om gezondheidsredenen af, en Roger De Vos werd de nieuwe voorzitter.

            </p>
        </section>
        <section>
            <p>
            In 1993 moest ook de dirigent, na 25 jaar dienst, om dezelfde redenen de dirigeerstok overdragen aan Dirk Acquet, een muzikant bij de muziekkapel van de zeemacht. Onder zijn leiding werd ook onze jeugdfanfare "De Moedige Muzikantjes" opgericht.

            </p>
            <p>
            In 2002 werd Dirk Acquet beroepsmatig bevorderd tot onderkapelmeester bij de Gidsen, wat het onmogelijk maakte om beide rollen te combineren. Hij gaf de dirigeerstok door aan Tim Van Medegael. Helaas duurde de samenwerking met Tim slechts één jaar. Het bestuur, onder impuls van Dirk Acquet, haalde in 2003 Stijn Roels binnen als nieuwe dirigent. In 2013 werd Stijn dirigent bij zijn oorspronkelijke vereniging, waarna Danny Van Uffel hem opvolgde.

            </p>
        </section>

        <img
        className="pictures"
        src='../images/nieuwere-foto.jpeg'
        alt="nieuwere-foto"
        style={{ borderRadius: '7vmax' }}
        />

        <section>
            <p>
            In 2014 bereikte onze fanfare een dieptepunt. Het bestuur was al jaren onderbezet en dat eiste zijn tol. Roger De Vos, 42 jaar bestuurslid, waarvan 32 jaar als voorzitter, diende zijn ontslag in en riep iedereen bijeen voor een Buitengewone Algemene Vergadering.

            </p>
        </section>
        <section>
            <p>
            Tijdens deze vergadering meldden zich ongeveer tien muzikanten aan om een nieuw bestuur op te richten, en Johan Theetaert werd de nieuwe voorzitter. Na twee jaar nam Bart Poedts het voorzitterschap over van Johan.

            </p>
            <p>
            In 2017 vierde de fanfare haar 110-jarig bestaan. Er werden nieuwe jasjes aangeschaft met de opbrengst van een wafelverkoop en een sponsoring van erevoorzitter Paul Doms. Ook kreeg het logo een frisse nieuwe uitstraling.

            </p>
            <p>
            Andreas Carlier volgde in september 2017 Danny Van Huffel op. Deze jonge tubaspeler studeerde aan het Koninklijk Conservatorium van Antwerpen en het Koninklijk Conservatorium van Brussel. Samen met hem investeerde het bestuur in de jeugd om de toekomst van de fanfare te waarborgen. Onder zijn leiding werd het Instaporkest opgericht.
            </p>
        </section>
    </main>
  );
};

export default Geschiedenis;
